<template>
  <div>
    <div class="ll-box">
    <!-- breadcrumb -->
    <div class="breadcrumb-top">
      <b-breadcrumb class="">
        <b-breadcrumb-item :to="{ name: 'dashboard' }">
          <feather-icon
            icon="HomeIcon"
            size="16"
          />
        </b-breadcrumb-item>
        <b-breadcrumb-item>
          {{ $t('User') }}
        </b-breadcrumb-item>
        <b-breadcrumb-item active >
          {{ $t('Role') }}
        </b-breadcrumb-item>
      </b-breadcrumb>
    </div>
    <!-- Add Btn -->
      <div class="d-flex justify-content-end">
        <b-button
          variant="info"
          :to="{ name: 'create-role' }"
          v-permission="[177]"
        >
          <span class="text-nowrap">{{ $t('Create') }}</span>
        </b-button>
      </div>
    </div>
    <!-- Filters -->
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="6">
            <b-input-group>
              <b-input-group-prepend
                is-text
                v-b-toggle.filterS
                class="ll-outline"
                :style="filterBg">
                 <svg class="ll-ficon" aria-hidden="true">
                  <use xlink:href="#icon-filter"></use>
                </svg>
              </b-input-group-prepend>
              <b-form-input
                v-model="roleName"
                class="searchInput"
                placeholder="Role Name"
              />
              <b-input-group-prepend
                is-text
                class="ll-searchBtn"
                @click="searchById"
                >
                <feather-icon
                  icon="SearchIcon"
                  class="mr-25"
                  size="18"
                />
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- Filters sidebar -->
    <b-sidebar id="filterS" title="" right shadow backdrop bg-variant="white">
      <div class="px-3">
        <app-collapse class="ll-collapse">
          <app-collapse-item :title="$t('Code Name')">
            <b-form-input
              v-model="condition.roleCode"
              placeholder=""
            />
          </app-collapse-item>
          <app-collapse-item :title="$t('Creation Date from-to')">
            <b-row>
              <b-col>
                <b-form-group
                  class="g-label ll-bform"
                  label="Creation date"
                  label-for="formTime"
                >
                  <flat-pickr
                    id="formTime"
                    v-model="condition.fromDate"
                    class="form-control"
                    :config="{ enableTime: true,dateFormat: 'Y-m-d H:i:ss'}"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  class="g-label ll-bform"
                  label="to"
                  label-for="toTime"
                >
                  <flat-pickr
                    id="toTime"
                    v-model="condition.toDate"
                    class="form-control"
                    :config="{ enableTime: false,dateFormat: 'Y-m-d H:i:ss'}"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </app-collapse-item>
          <app-collapse-item :title="$t('Is Active')">
            <v-select
              id="isActive"
              :options="statusList"
              label="status"
              @input="selStatus"
              placeholder=""
              v-model="status"
            ></v-select>
          </app-collapse-item>
        </app-collapse>
        <div class="ll-btn">
          <b-button
            variant="secondary"
            class="mr-1"
            @click="onClear"
          >
            {{ $t('Clear') }}
          </b-button>
          <b-button variant="info"
            @click="getList"
            v-b-toggle.filterS>
            {{ $t('Search') }}
          </b-button>
        </div>
      </div>
    </b-sidebar>

    <!-- table -->
    <b-table
      ref="refUserListTable"
      class="position-relative ll-table"
      :items="rows"
      :fields="columns"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      :striped="true"
      :hover="true"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @sort-changed="onSortChange"
      v-permission="[176]"
      :sticky-header="true"
      :busy="isBusy"
      @row-clicked="onDetail"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template #cell(statusType)="row">
        {{ row.value.toLowerCase().replace('_', ' ') }}
      </template>
      <template #cell(statusDesc)="row">
        {{ row.value.toLowerCase().replace('_', ' ') }}
      </template>
      <template #cell(intCode)="row">
        {{ row.value.toLowerCase().replace('_', ' ') }}
      </template>
      <template #cell(tag)="row">
        <b-badge
          pill
          variant="light-primary"
          class="ll-badge">
          <span v-if="row.value !== ''">{{ row.value.toLowerCase().replace('_', ' ') }}</span>
        </b-badge>
      </template>
      <template #cell(status)="row">
        <b-badge
          v-if="row.value === 0"
          variant="light-info"
          class="ll-badge">
          <span>{{ $t('Unknown') }}</span>
        </b-badge>
        <b-badge
          v-if="row.value === 1"
          variant="light-info"
          class="ll-badge">
          <span>{{ $t('Active') }}</span>
        </b-badge>
        <b-badge
          v-if="row.value === 2"
          variant="light-info"
          class="ll-badge">
          <span>{{ $t('Inactive') }}</span>
        </b-badge>
      </template>
      <!-- Column: Actions -->
      <template #cell(action)="data">
        <b-button
          variant="flat-secondary"
          class="btn-icon rounded-circle ll-act"
          @click="onDetail(data.item)"
          v-permission="[178]"
        >
          <feather-icon icon="EditIcon"/>
        </b-button>
      </template>
    </b-table>
    <!-- show pages -->
    <div class="d-flex justify-content-between flex-wrap ll-p">
      <div class="d-flex align-items-center mb-0 mr-1">
        <span class="text-nowrap ">
          Showing 1 to
        </span>
        <b-form-select
          v-model="size"
          :options="pageOptions"
          class="mx-1"
          @input="handlePageChange"
        />
        <span class="text-nowrap"> of {{ totalSize }} entries </span>
      </div>
      <div>
        <b-pagination
          v-model="page"
          :total-rows="totalSize"
          :per-page="size"
          first-number
          last-number
          class="mb-0 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
          @change="handleChangePage"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BPagination,
  BFormGroup,
  BFormSelect,
  BFormInput,
  BButton,
  // BTooltip,
  BCard,
  BCardBody,
  BRow,
  BCol,
  BSidebar,
  VBToggle,
  BTable,
  BInputGroupPrepend,
  BInputGroup,
  BBreadcrumb,
  BBreadcrumbItem,
  BBadge, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import permission from '@core/directives/permission/index.js'

export default {
  components: {
    BPagination,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BButton,
    // BTooltip,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BSidebar,
    vSelect,
    BTable,
    BInputGroupPrepend,
    BInputGroup,
    BBreadcrumb,
    BBreadcrumbItem,
    BBadge,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    flatPickr,
    AppCollapse,
    AppCollapseItem,
    BSpinner,
  },
  directives: {
    'b-toggle': VBToggle,
    permission,
  },
  data() {
    return {
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      pageOptions: [50, 100, 200],
      page: null, // 当前页码
      size: 15, // 每页个数
      totalSize: null, // 总个数
      totalPage: null, // 总页数
      columns: [
        { key: 'id', label: this.$t('Role Id'), sortable: true },
        { key: 'orgName', label: this.$t('Organization'), sortable: true },
        { key: 'roleName', label: this.$t('Role Name'), sortable: true },
        { key: 'createdAt', label: this.$t('Creation Time'), sortable: true },
        { key: 'operator', label: this.$t('Operator'), sortable: true },
        { key: 'status', label: this.$t('Status'), sortable: true },
        { key: 'action', label: this.$t('Action'), class: 'll-action' },
      ],
      rows: [],
      searchTerm: '',
      statusTypeList: [],
      statusList: [
        { value: null, status: 'all' },
        { value: true, status: 'active' },
        { value: false, status: 'inactive' },
      ],
      formTime: '',
      toTime: '',
      condition: {
        page: '1',
        size: '50',
        orderMole: 0,
        orderBy: 'r.roleId',
        orgId: Number,
        status: null,
        roleCode: '',
        roleName: '',
        fromDate: '',
        toDate: '',
      },
      roleName: '',
      orgId: '',
      filterBg: {
        '--background': '#fff'
      },
      status: null,
      isBusy: true,
    }
  },
  watch: {
    'condition.roleCode'(val) {
      this.setBg(val)
    },
    'condition.fromDate'(val) {
      this.setBg(val)
    },
    'condition.toDate'(val) {
      this.setBg(val)
    },
    'status'(val) {
      this.setBg(val)
    },
  },
  computed: {},
  created() {
  },
  mounted() {
    this.getList()
    this.getStatusType()
  },
  methods: {
    // filter图标背景颜色设置
    setBg(val) {
      if (val !== null && val !== '') {
        this.filterBg= {
          '--background': '#ff9f43'
        }
      } else {
        this.filterBg= {
          '--background': '#fff'
        }
      }
    },
    // 首次查询
    getList() {
      this.$http.post('/admin/settings/role/search', this.condition).then(res => {
        // console.log('ss', res.data.data)
        const info = res.data.data
        this.rows = info.content
        this.page = info.page
        this.size = info.size
        this.totalSize = info.totalSize
        this.totalPage = info.totalPage
        this.isBusy = false
      }).catch(error => console.log(error))
    },
    // 点击单行
    onRowClick() {
      // console.log('onRowClick')
    },
    onSearch() {
      // console.log('onSearch')
    },
    onClear() {
      // this.condition = {}
      this.condition.roleCode = null
      this.condition.fromDate = null
      this.condition.toDate = null
      this.status = null
    },
    // 条件过滤搜索
    filterSearch() {
      console.log(this.condition)
      this.getList()
    },
    // 排序规则
    onSortChange(params) {
      const orderBy = params.sortBy
      const orderMole = params.sortDesc ? 0 : 1
      // this.condition.orderBy = orderBy
      this.condition.orderMole = orderMole
      switch (orderBy) {
        case 'id':
          this.condition.orderBy = 'r.roleId'
          break
        case 'orgName':
          this.condition.orderBy = 'o.name'
          break
        case 'roleName':
          this.condition.orderBy = 'r.roleName'
          break
        case 'createdAt':
          this.condition.orderBy = 'r.createdAt'
          break
        case 'operator':
          this.condition.orderBy = 'r.operator'
          break
        default:
          this.condition.orderBy = 'status'
          break
      }
      this.getList()
    },
    // 根据code查询
    searchById() {
      if (this.roleName.trim() !== '') {
        this.condition.roleName = this.roleName.trim()
        this.getList()
      } else {
        this.condition = {}
        this.getList()
      }
    },
    // 获取status Type
    getStatusType() {
      this.$http.get('statusManagement/getStatusTypeList').then(res => {
        this.statusTypeList = res.data.data
      })
    },
    selStatusType(type) {
      this.condition.statusType = type.statusType.split()
    },
    selStatus(s) {
      this.condition.isEnabled = s.value
      this.status = s.status
    },
    // 分页
    handleChangePage(page) {
      this.condition.page = page
      this.getList()
    },
    handlePageChange(active) {
      this.condition.size = active
      this.getList()
    },
    onDetail(item){
      this.$http.get('admin/settings/role/getInfoById', { params: { id: item.id }}).then(res =>{
        if (res.data.code == '200') {
          const info = res.data.data
          this.$router.push({ name: 'role-detail', params: { roleId: item.id, roleInfo: info }})
        }
      })
    },
  },
}
</script>
<style scoped>
/* .ll-p{
  position: fixed;
  bottom: 40px;
  right: 10px;
} */
.ll-btn{
  position: fixed;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding-right: 6rem;
  width: 100%;
}
.ll-btnS{
  margin-right: 20px;
}
.ll-colBox{
  margin: auto;
}
.ll-outline{
  outline: none;
}
.ll-searchBtn div{
  background-color: #ff9f43;
  color: #fff;
  width: 60px;
  display: flex;
  justify-content: center;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}
.ll-box{
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-bottom: 10px;
}
.ll-act{
  height: 15px;
  width: 15px;
}
.btn .feather{
  position: relative;
  top: -8px;
  left: -5px;
}
.ll-outline> div{
  background: var(--background);
}
</style>
<style>
[dir] .vgt-table.bordered th{
  padding: 10px;
  font-size: 12px;
}
table.vgt-table{
  font-size: 12px;
}
[dir=ltr] .b-sidebar.b-sidebar-right > .b-sidebar-header .close{
  margin-left: unset;
  margin-right: unset;
  font-size: 20px;
}
[dir=ltr] .b-sidebar.b-sidebar-right{
  width: 25%;
}
[dir] .page-item.active{
  height: 27px;
}
.table thead th, .table tfoot th {
  text-transform: capitalize;
}
</style>
